import { ALL_USER_ROLES } from '../../constants/roles/userRoleTypes';
import { entityModalTypes } from './modals/entityModalTypes';

const {
    ASSISTERENROLLMENTENTITY,ASSISTERENROLLMENTENTITYADMIN, ADMIN
} = ALL_USER_ROLES;

export const fields = {
    CEC_FIRST_NAME : 'firstName',
    CEC_LAST_NAME : 'lastName',
    CEC_STATUS:'status',
    CEC_EMAIL:'emailAddress',
    CEC_EMAIL_LABEL : 'emailAddressLabel',
    CEC_LICENCE_NUMBER : 'assisterNumber',
    CEC_NAME : 'cecName',
    CEC_RD_BTN:'pickCEC',    
    ENTITY_SITE : 'primarySite',
    PRIMARY_SITE : 'primarySiteLabel',
    ENTITY_NAME : 'entityName',
    ENTITY_NAME_LABEL : 'entityNamelabel',
    ENTITY_FEDERAL_TAX_ID : 'entityFederalTaxId',
    BOB_REASSIGN_BTN : 'bobReassignBtn'
};


export const labelNames = {
    [fields.CEC_FIRST_NAME]: 'common.cec_first_name',
    [fields.CEC_LAST_NAME]: 'common.cec_last_name',
    [fields.CEC_NAME]:'common.cecFullName',
    [fields.CEC_STATUS]:'common_cec_status',
    [fields.CEC_EMAIL] :'common.cec_email',
    [fields.CEC_LICENCE_NUMBER] :'common.cec_license_number',
    [fields.CEC_RD_BTN]:'common.cec_rd_btn',
    [fields.CEC_EXPORT_BTN]:'common.cec_export_btn' ,
    [fields.ENTITY_SITE]:'common.entity_site',
    [fields.PRIMARY_SITE]:'cec.primary_site',
    [fields.ENTITY_NAME] :'common.entity_name',
    [fields.ENTITY_NAME_LABEL]:'common.entity_name_label',
    [fields.ENTITY_FEDERAL_TAX_ID] : 'common.entity_federal_tax_id',
    [fields.BOB_REASSIGN_BTN] : 'common.bob_reassign_btn',
    [fields.CEC_EMAIL_LABEL]:'common.cec_email_label'
};

export const headersByType ={
    [fields.CEC_EXPORT_BTN] :'link',
    [fields.BOB_REASSIGN_BTN] :'button'
};

export const tableHeadersByRole = {    
    [ASSISTERENROLLMENTENTITY]:[
        fields.CEC_RD_BTN,
        fields.CEC_NAME,        
        fields.CEC_STATUS,
        fields.CEC_EMAIL_LABEL,
        fields.PRIMARY_SITE,
        fields.BOB_REASSIGN_BTN
    ],
    [ASSISTERENROLLMENTENTITYADMIN] :[
        fields.CEC_RD_BTN,
        fields.ENTITY_NAME_LABEL,
        fields.ENTITY_FEDERAL_TAX_ID,
        fields.CEC_NAME,        
        fields.CEC_LICENCE_NUMBER,
        fields.CEC_STATUS,
        fields.BOB_REASSIGN_BTN
    ]
};

// export const filterTypesLocal ={
    
//     [ASSISTERENROLLMENTENTITY] : {
//         [fields.CEC_FIRST_NAME] : { type : 'text' },
//         [fields.CEC_LAST_NAME] : { type:'text' },
//         [fields.CEC_LICENCE_NUMBER] : { type:'text' },
//         [fields.CEC_EMAIL] : { type:'text' },
//         [fields.ENTITY_SITE]: { type:'dropdown', values : [fields.ENTITY_SITE] }
//     }    
// };

export const filtersByRole = {
    [ASSISTERENROLLMENTENTITY]:[
        fields.CEC_FIRST_NAME,
        fields.CEC_LAST_NAME,
        fields.CEC_LICENCE_NUMBER,
        fields.CEC_EMAIL,
        fields.ENTITY_SITE
    ],
    [ASSISTERENROLLMENTENTITYADMIN]:[
        fields.ENTITY_NAME,
        fields.ENTITY_FEDERAL_TAX_ID,
        fields.CEC_FIRST_NAME,
        fields.CEC_LAST_NAME,
        fields.CEC_LICENCE_NUMBER
    ]
};

export const filterInputsMaxLength = {    
    [fields.CEC_FIRST_NAME] : 50,
    [fields.CEC_LAST_NAME] : 50    
};

export const DELEGATION_REASONS = {
    AGENT_CEC_CERTIFICATION_ENDED:	'delegation.reasons.certification_ended',
    AGENT_CEC_INITIATED_DEDESIGNATION:	'delegation.reasons.initiated_de_designation',
    CONSUMER_REQUESTED_CANCELLATION:	'delegation.reasons.cancellation',
    TRANSFER_WITHIN_AGENCY_ENTITY: 'delegation.reasons.transfer',
    ACCELERATED_CONSUMER_DELEGATION_CONSENT: 'delegation.reasons.accelerated'
};

export const DELEGATION_HEADER_TYPES = {    
    [ASSISTERENROLLMENTENTITY]:'CEC_filter_header_for_entitymgr',
    [ASSISTERENROLLMENTENTITYADMIN]:'EntityAdmin_CEC_filter_header',
};

export const DELEGATION_FILTER_TITLE_TYPES = {    
    [ASSISTERENROLLMENTENTITY]:'CEC_filter_title_for_entitymgr',
    [ASSISTERENROLLMENTENTITYADMIN]:'EntityAdmin_CEC_filter_title',
};

export const TRANSFER_DISPLAY_MSG_TYPE = {
    [ASSISTERENROLLMENTENTITY]:'CEC_display_message_for_entity_mgr',
    [ASSISTERENROLLMENTENTITYADMIN]:'CEC_display_message_for_entity_admin'
};

export const DELEGATION_ALERT_MSGS = {
    DEFAULT: 'CEC_no_result_found',    
    ENTITYADMIN_PAGE_LOAD : 'assister_page_load'
};

export const TRANSFER_MODAL_MSG = {
    'Agency':{
        [entityModalTypes.TRANSFER_ERROR_MODAL] : 'bob.transfer.agency.error.msg',
        [entityModalTypes.TRANSFER_FAILURE_MODAL] : 'bob.transfer.agency.failure.msg',
        [entityModalTypes.TRANSFER_INCOMPLETE_MODAL] : 'bob.transfer.agency.incomplete.msg',
        [entityModalTypes.TRANSFER_PARTIAL_SUCCESS_MODAL] : 'bob.transfer.agency.partial_success.msg',
        [entityModalTypes.TRANSFER_SUCCESS_MODAL] : 'bob.transfer.agency.success.msg',
        [entityModalTypes.TRANSFER_IN_PROGRESS_MODAL] : 'bob.transfer.agency.in_progress.msg',
        [entityModalTypes.TRANSFER_VALIDATION_ERROR_MODAL] : 'bob.transfer.agency.validation_error.msg'
    },
    [ASSISTERENROLLMENTENTITY] :{
        [entityModalTypes.TRANSFER_ERROR_MODAL] : 'bob.transfer.error.entity_mgr.msg',
        [entityModalTypes.TRANSFER_FAILURE_MODAL] : 'bob.transfer.failure.entity_mgr.msg',
        [entityModalTypes.TRANSFER_INCOMPLETE_MODAL] : 'bob.transfer.incomplete.entity_mgr.msg',
        [entityModalTypes.TRANSFER_PARTIAL_SUCCESS_MODAL] : 'bob.transfer.partial_success.entity_mgr.msg',
        [entityModalTypes.TRANSFER_SUCCESS_MODAL] : 'bob.transfer.success.entity_mgr.msg',
        [entityModalTypes.TRANSFER_IN_PROGRESS_MODAL] : 'bob.transfer.in_progress.entity_mgr.msg',
        [entityModalTypes.TRANSFER_VALIDATION_ERROR_MODAL] : 'bob.transfer.validation_error.entity_mgr.msg'
    },
    [ASSISTERENROLLMENTENTITYADMIN]:{
        [entityModalTypes.TRANSFER_ERROR_MODAL] : 'bob.transfer.error.msg',
        [entityModalTypes.TRANSFER_FAILURE_MODAL] : 'bob.transfer.failure.msg',
        [entityModalTypes.TRANSFER_INCOMPLETE_MODAL] : 'bob.transfer.incomplete.msg',
        [entityModalTypes.TRANSFER_PARTIAL_SUCCESS_MODAL] : 'bob.transfer.partial_success.msg',
        [entityModalTypes.TRANSFER_SUCCESS_MODAL] : 'bob.transfer.success.msg',
        [entityModalTypes.TRANSFER_IN_PROGRESS_MODAL] : 'bob.transfer.in_progress.msg',
        [entityModalTypes.TRANSFER_VALIDATION_ERROR_MODAL] : 'bob.transfer.validation_error.msg'
    },
    [ADMIN]:{
        [entityModalTypes.TRANSFER_ERROR_MODAL] : 'bob.transfer.error.msg',
        [entityModalTypes.TRANSFER_FAILURE_MODAL] : 'bob.transfer.failure.msg',
        [entityModalTypes.TRANSFER_INCOMPLETE_MODAL] : 'bob.transfer.incomplete.msg',
        [entityModalTypes.TRANSFER_PARTIAL_SUCCESS_MODAL] : 'bob.transfer.partial_success.msg',
        [entityModalTypes.TRANSFER_SUCCESS_MODAL] : 'bob.transfer.success.msg',
        [entityModalTypes.TRANSFER_IN_PROGRESS_MODAL] : 'bob.transfer.in_progress.msg',
        [entityModalTypes.TRANSFER_VALIDATION_ERROR_MODAL] : 'bob.transfer.validation_error.msg'
    }
};

export const TRANSFER_PAGE_TYPE ={
    CONSUMER :'consumer',
    ASSISTER :'assister',
    ENTITY_MANAGER : 'entity_manager'
};

export const TRANSFER_ACTION_TYPE = {
    DEFAULT : 'Transfer',
    DELEGATION : 'change_delegation'
};